import { useState } from 'react';
import { Button, Card, Typography } from 'antd';
import styles from './NoPlans.module.scss';
import { useIntl } from 'react-intl';
import { OpenAccount } from 'features/account/add-account';

const NoPlans = () => {
  const { formatMessage: t } = useIntl();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <>
      <Card className={styles.card}>
        <Typography.Title level={3} style={{ marginBottom: 32 }}>
          Weststein
        </Typography.Title>
        <Button type='primary' className={styles.button} block onClick={showModal}>
          {t({ id: 'screens.dashboard.openAccount' })}
        </Button>
      </Card>

      <OpenAccount open={isModalOpen} onClose={closeModal} />
    </>
  );
};

export default NoPlans;
